<div
  class="wrapper"
  [ngStyle]="{
    marginLeft: isHideIcon ? '0px' : '5px',
  }"
>
  <div class="position-relative">
    @if (!isHideIcon) {
      <span class="icon">
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M7.41668 0.833344C7.41668 0.41913 7.08089 0.0833435 6.66668 0.0833435C6.25246 0.0833435 5.91668 0.41913 5.91668 0.833344V1.78623C5.89207 1.78911 5.86779 1.79221 5.84377 1.79556C3.7414 2.08883 2.08883 3.7414 1.79556 5.84377C1.7499 6.17107 1.74994 6.54727 1.75 7.13866L1.75001 7.20589V11.1L1.75001 11.133C1.75 12.2252 1.75 13.0907 1.807 13.7883C1.86528 14.5017 1.98689 15.1053 2.26773 15.6565C2.72313 16.5502 3.44978 17.2769 4.34355 17.7323C4.89473 18.0131 5.49835 18.1347 6.21174 18.193C6.90935 18.25 7.77482 18.25 8.86692 18.25H8.86699H8.90001H11.1H11.133H11.1331C12.2252 18.25 13.0907 18.25 13.7883 18.193C14.5017 18.1347 15.1053 18.0131 15.6565 17.7323C16.5502 17.2769 17.2769 16.5502 17.7323 15.6565C18.0131 15.1053 18.1347 14.5017 18.193 13.7883C18.25 13.0906 18.25 12.2251 18.25 11.133V11.1V8.90001V8.86704C18.25 7.77488 18.25 6.90937 18.193 6.21174C18.1347 5.49835 18.0131 4.89473 17.7323 4.34356C17.2769 3.44979 16.5502 2.72313 15.6565 2.26773C15.1829 2.02645 14.6707 1.9027 14.0833 1.83566V0.833344C14.0833 0.41913 13.7476 0.0833435 13.3333 0.0833435C12.9191 0.0833435 12.5833 0.41913 12.5833 0.833344V1.75673C12.1498 1.75 11.6687 1.75001 11.133 1.75001L11.1 1.75001H7.41668V0.833344ZM12.5833 3.33334V3.25691C12.1593 3.25016 11.6715 3.25001 11.1 3.25001H7.41668V3.33334C7.41668 3.74756 7.08089 4.08334 6.66668 4.08334C6.25246 4.08334 5.91668 3.74756 5.91668 3.33334V3.30276C4.54258 3.55301 3.47554 4.65763 3.28118 6.051C3.25182 6.26143 3.25001 6.52495 3.25001 7.20589V11.1C3.25001 12.2325 3.25059 13.0367 3.30202 13.6661C3.35272 14.2868 3.4491 14.671 3.60424 14.9755C3.91583 15.587 4.41301 16.0842 5.02454 16.3958C5.32901 16.5509 5.71326 16.6473 6.33389 16.698C6.96327 16.7494 7.76753 16.75 8.90001 16.75H11.1C12.2325 16.75 13.0367 16.7494 13.6661 16.698C14.2868 16.6473 14.671 16.5509 14.9755 16.3958C15.587 16.0842 16.0842 15.587 16.3958 14.9755C16.5509 14.671 16.6473 14.2868 16.698 13.6661C16.7494 13.0367 16.75 12.2325 16.75 11.1V8.90001C16.75 7.76753 16.7494 6.96327 16.698 6.33389C16.6473 5.71326 16.5509 5.32901 16.3958 5.02454C16.0842 4.41301 15.587 3.91583 14.9755 3.60424C14.7458 3.48723 14.4708 3.40365 14.0832 3.34787C14.0755 3.75538 13.7427 4.08334 13.3333 4.08334C12.9191 4.08334 12.5833 3.74756 12.5833 3.33334ZM5.83335 5.91668C5.41914 5.91668 5.08335 6.25246 5.08335 6.66668C5.08335 7.08089 5.41914 7.41668 5.83335 7.41668H14.1667C14.5809 7.41668 14.9167 7.08089 14.9167 6.66668C14.9167 6.25246 14.5809 5.91668 14.1667 5.91668H5.83335ZM7.50002 10C7.50002 10.4602 7.12692 10.8333 6.66669 10.8333C6.20645 10.8333 5.83335 10.4602 5.83335 10C5.83335 9.53977 6.20645 9.16668 6.66669 9.16668C7.12692 9.16668 7.50002 9.53977 7.50002 10ZM6.66669 14.1667C7.12692 14.1667 7.50002 13.7936 7.50002 13.3333C7.50002 12.8731 7.12692 12.5 6.66669 12.5C6.20645 12.5 5.83335 12.8731 5.83335 13.3333C5.83335 13.7936 6.20645 14.1667 6.66669 14.1667ZM10.8334 13.3333C10.8334 13.7936 10.4603 14.1667 10 14.1667C9.53978 14.1667 9.16669 13.7936 9.16669 13.3333C9.16669 12.8731 9.53978 12.5 10 12.5C10.4603 12.5 10.8334 12.8731 10.8334 13.3333ZM13.3334 14.1667C13.7936 14.1667 14.1667 13.7936 14.1667 13.3333C14.1667 12.8731 13.7936 12.5 13.3334 12.5C12.8731 12.5 12.5 12.8731 12.5 13.3333C12.5 13.7936 12.8731 14.1667 13.3334 14.1667ZM10.8334 10C10.8334 10.4602 10.4603 10.8333 10 10.8333C9.53978 10.8333 9.16669 10.4602 9.16669 10C9.16669 9.53977 9.53978 9.16668 10 9.16668C10.4603 9.16668 10.8334 9.53977 10.8334 10ZM13.3334 10.8333C13.7936 10.8333 14.1667 10.4602 14.1667 10C14.1667 9.53977 13.7936 9.16668 13.3334 9.16668C12.8731 9.16668 12.5 9.53977 12.5 10C12.5 10.4602 12.8731 10.8333 13.3334 10.8333Z"
            fill="#B6B6B6"
          />
        </svg>
      </span>
    }
    <input
      readonly
      [class.small-input]="isHideIcon"
      [placeholder]="placeholder"
      [class.placeholder]="placeholder && !value"
      [class.error]="!viewOnly && showError && errorMessage"
      class="value d-block"
      [class.viewonly]="viewOnly"
      [class.focused]="focused || dp?.opened"
      [value]="value | date: 'MMM dd, yyyy'"
      (keyup.enter)="openCalendar(picker)"
      (keyup.Space)="openCalendar(picker)"
      [disabled]="disabled"
      (focusin)="focused = true"
      (focusout)="focused = false"
      [id]="calenderId"
      (click)="openCalendar(picker)"
    />
    <input
      #input
      class="invisible position-absolute"
      style="top: 20px"
      readonly
      matInput
      [matDatepicker]="dp"
      [placeholder]="label"
      [class.invalid]="showError"
      [class.focused]="focused || dp?.opened"
      [min]="minDate"
      [max]="maxDate"
      [(ngModel)]="value"
    />
    @if ((!viewOnly || isHideIcon) && !hideLabel) {
      <label [class.execution-label]="isHideIcon">{{ label }}</label>
    }
    @if (!viewOnly && showError && errorMessage && !isHideIcon) {
      <span class="error-msg">{{ errorMessage }}</span>
    }
  </div>
  <mat-datepicker
    #dp
    [disabled]="disabled"
    #picker="matDatepicker"
    (closed)="closeCalendar()"
  >
  </mat-datepicker>
</div>
